import { Flexbox } from "st-app";
import { GroupAction } from "./GroupAction";
import { Group } from "./Group";

import styles from '../sis-role-dashboard.module.css'
import { UserSuggestions } from "./UserSuggestions";
import { UserRecentHistory } from "./UserRecentHistory";
import { For, createMemo } from "solid-js";
import { requireRoleDashboardContext } from "../RoleDashboardContext";
import { StaffRole } from "../../../api";

export function DistrictStateReportingDashboard() {
    const ctx = requireRoleDashboardContext();

    const tasks = ctx.sortedActions([
    ]);

    const shortcuts = createMemo(() => {
        const addShortcuts = ctx.configuration()
            ?.additionalShortcuts
            .filter(desc => desc.role === StaffRole.DistrictStateReporting)
            .map(desc => desc.ID!);

        return ctx.sortedActions([
            'DistrictSRC.ScheduleBasedFTE',
            'DistrictSRC.StateReporting',
            'DistrictSRC.Rules',
            'DistrictSRC.CTEDashboard',
            'DistrictSRC.FTESegments',
        ].concat(addShortcuts ?? []));
    });

    return <Flexbox dir="horizontal" auto class={styles['dashboard-content']} >
        <Flexbox dir="vertical" auto>
            <Group title="Shortcuts" icon="fas fa-info-circle" color="--header-blue">
                <For each={shortcuts()}>{id => <GroupAction id={id} allowDetach />}</For>
            </Group>

            <UserSuggestions />
            <Flexbox.Item auto />
        </Flexbox>
        <UserRecentHistory />
    </Flexbox>
}

